import React, { ChangeEventHandler } from "react";
import { Grid, TextField } from "@mui/material";

type GridRowDescriptionWithTextField = {
  description: string;
  value: string;
  onChange: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
};

function GridRowDescriptionWithTextField(props: GridRowDescriptionWithTextField) {
  return (
    <>
      <Grid item xs={6}>
        {props.description}
      </Grid>
      <Grid container item justify={"flex-end"} xs={6}>
        <TextField onChange={props.onChange} value={props.value} />
      </Grid>
    </>
  );
}

export default GridRowDescriptionWithTextField;
